import React, { Component, Fragment } from 'react';
import ResultChart from './components/ResultChart';
import styled, { injectGlobal } from 'styled-components';
import { Box } from 'grid-styled';
import Icon from '../../components/Icon/Icon';
import { QUERY_GET_SAP } from '../../services/graphql/discover-query';
import P from '../../components/P/P';
import { Query } from 'react-apollo';
import moment from 'moment';
import { inject, observer } from 'mobx-react';

injectGlobal`
  #root > div > header {
    //display: none;
  }
  
  .c-page {
    padding: 30px 50px;
    height: 1123px;
    width: 794px;
  
    box-shadow: 0 9px 20px -15px #7a8198;
    margin: 16px auto;
  
    display: flex;
    flex-direction: column;
  
    background-color: white;
    position: relative;
  }
  
  .c-page__main {
    flex: 1 0 auto;
    display: flex;
    flex-direction: column;
  }
  
  .c-page__header,
  .c-page__footer {
    background: white;
  }

  .c-page__header {
    //padding: 16px;
    margin: 96px 0;
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
  }
  
  .c-page--form .c-page__header {
    //padding: 0 16px;
    align-items: center;
    margin: 0 0 50px;
    padding-bottom: 20px;
    border-bottom: 1px solid #7a819888;
  }
  
  .c-page__header-logo {
    max-width: 120px;
  }

  .c-page__header-two-col {
    display: flex;
  
  }
  
  .c-page__header-two-col .c-page__header-field {
    flex: 1 1 50%;
  }

  .c-page__header-field {
    line-height: 2;
    border-bottom: 1px solid #d6dadc;
  }
  
  .c-page__header-title {
    display: flex;
    margin-bottom: 8px;
    //font-family: $font-family-primary-bold;
  
    //@include inuit-font-size($inuit-font-size-h3);
  }
  .c-page__header-title .c-page__header-subtext {
    //font-family: $font-family-primary-light;
    margin-left: 16px;
  }

  .c-page__header-meta {
    //font-family: $font-family-primary-light;

    display: flex;
    flex-direction: column;
    margin-bottom: 32px;
    font-size: 20px;
  }

  .c-page__header-organisations {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
    margin-left: 30px;
  }

  .c-page__header-logo {
    max-width: 50%;
  }

  .c-page__footer {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    //font-family: $font-family-primary-light;
    margin: 16px 8px;
    font-size: 10px;
  }

  .c-page__footer > * {
    flex: 1 1 calc(100% / 3);

  }
  
  .c-page__footer > *:nth-child(2) {
    text-align: center;
  }

  .c-page__footer > *:last-child {
    text-align: right;
  }

  .c-page__footer-image {
    max-width: 80px;
  }
  
  .c-page__footer-logo {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    flex: 0 0 136px;
  }
  
  .c-page__footer-page-number {
    justify-content: flex-end;
  }
  
@page {
  // size: A4;
  margin: 0;
}

@media print {
  /**
   * 1. Black prints faster: http://www.sanbeiji.com/archives/953
   */

  // *,
  // *:before,
  // *:after {
  // background: transparent !important;
  // color: #000 !important; /* [1] */
  // box-shadow: none !important;
  // text-shadow: none !important;
  // }

  html,
  body {
    // width: 210mm;
    width: 100%;
    page-break-inside: avoid;
    position: relative;
    background-color: #fff;
  }

  a,
  a:visited {
    text-decoration: underline;
  }

  a[href]:after:not(.c-report-footer__link) {
    content: " (" attr(href) ")";
  }

  abbr[title]:after {
    content: " (" attr(title) ")";
  }

  /**
   * Don’t show links that are fragment identifiers, or use the \`javascript:\`
   * pseudo protocol.
   */

  a[href^="#"]:after,
  a[href^="javascript:"]:after {
    content: none;
  }

  pre,
  blockquote {
    border: 1px solid #999;
    page-break-inside: avoid;
  }

  /**
   * Printing Tables: http://css-discuss.incutio.com/wiki/Printing_Tables
   */

  thead {
    display: table-header-group;
  }

  tr,
  img {
    page-break-inside: avoid;
  }

  img {
    max-width: 100% !important;
  }

  p,
  h2,
  h3,
  H5 {
    orphans: 3;
    widows: 3;
  }

  h2,
  h3,
  H5 {
    page-break-after: avoid;
  }
  
  H5 {
    font-size: 16px;
    margin-top: 8px;
    margin-bottom: 4px;
    font-family: ${props => props.theme.fonts.fontfaceRegular};
    color: ${props => props.theme.colors.primary};
    text-transform: uppercase;
    text-decoration: underline;
  }

  .c-page{
    height: auto;
    min-height: 100%;
    min-height: 296mm;
    max-height: 296.5mm;

    box-shadow: none;
    margin: 0 auto;
    position: relative;
  }
  
}
`;

const PrintContent = styled(Box)`
  width: 100%;
`;

const H1 = styled.h1`
  display: inline-block;
  font-weight: 900;
  font-family: ${props => props.theme.fonts.fontfaceRegular};
  line-height: 1.2;
  margin: 0;
  margin-bottom: 10px;
  font-size: ${props => props.theme.fonts.sizeH3};
  color: ${props => props.theme.colors.primary};
  transition: all 0.25s ease-in-out;
  `;

const H5 = styled.h5`
  font-size: 16px;
  margin-top: 8px;
  margin-bottom: 4px;
  font-family: ${props => props.theme.fonts.fontfaceRegular};
  color: ${props => props.theme.colors.primary};
  text-transform: uppercase;
  text-decoration: underline;
`;

const PrintP = styled.p`
  font-family: ${props => props.theme.fonts.fontfaceBeta};
  font-size: 10pt;
  line-height: 1.3;
  margin: 0 0 8px;
  text-align: justify;
  text-justify: inter-word;
`;

const PrintTopP = styled.p`
  font-family: ${props => props.theme.fonts.fontfaceBeta};
  font-size: 12pt;
  color: ${props => props.theme.colors.primary};
  font-weight: 900;
  line-height: 1.3;
  margin: 15px 0 8px;
  text-align: center;
  text-justify: inter-word;
`;

const CtaLink = styled.a`
    font-size: 24px;
    font-family: ${props => props.theme.fonts.fontfaceRegular};
    color: ${props => props.theme.colors.primary};
    margin: 0 0 60px;
    text-align: center;
`;

@inject('authStore')
@observer
export default class ResultView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: moment().format('DD-MM-YYYY')
    };
  }

  componentDidMount() {}

  render() {
    const { authStore: { user, isImpersonator }} = this.props;
    return (
      <PrintContent>
        <div className="c-page-breaker" />
        <Query query={QUERY_GET_SAP} fetchPolicy={'cache-and-network'} variables={{personId: isImpersonator ? isImpersonator.id : user.id}}>
          {({ loading, error, data }) => {
            if (loading) return <P>Bezig met laden...</P>;
            if (error) return <P danger>{error.message}</P>;
            const discoverData = data && data.getDiscovers;
            if (!discoverData || !discoverData[0]) {
              return (
                <section className="c-page c-page--form">
                <header className="c-page__header">
                  <div className="c-page__header-test-info">
                    <Icon id="ugent" />
                  </div>
                  <div className="c-page__header-organisations">
                    <Icon id="ugent-ge" fillColor="rgb(30,100,200)" width="230px" />
                  </div>
                </header>

                <div className="c-page__main">
                  <PrintP>Je hebt nog geen gepersonaliseerd resultaat, gelieve eerst de vragen lijst in te vullen</PrintP>
                </div>

                <footer className="c-page__footer">
                  <div className="c-page__footer-logo" />
                  <span className="c-page__footer-page-number">
              Page <span className="js-footer-pagination">1</span> - Mboek -
              M-factor op { this.state.date }
            </span>
                </footer>
              </section>)

            }
            return (
              <Fragment>

        <section className="c-page c-page--form">
          <header className="c-page__header">
            <div className="c-page__header-test-info">
              <Icon id="ugent" />
            </div>
            <div className="c-page__header-organisations">
              <Icon id="ugent-ge" fillColor="rgb(30,100,200)" width="230px" />
            </div>
          </header>

          <div className="c-page__main">
            <H1>Gepersonaliseerd profiel</H1>
            <PrintTopP>
              Voordat je jouw gepersonaliseerd profiel hieronder bekijkt,<br/>
            </PrintTopP>
            <CtaLink href="https://dc-backend-vob-platform.s3-eu-west-1.amazonaws.com/Vlot_van_start_met_V-Observer.pdf" target="_blank" rel="noopener noreferrer" >KLIK HIER</CtaLink>

            <ResultChart
              data={JSON.parse(
                discoverData[discoverData.length - 1].data
              )}
            />

            <H5>Participatief</H5>
            <PrintP>
              Een participatieve benadering betekent dat je in
              dialoog gaat met je sporters en ruimte biedt voor inspraak.
              Bovendienprobeer je – waar mogelijk – keuzes in te bouwen over hoe
              activiteiten worden aangepakt en volg je zo goed mogelijkhet
              ontwikkelingsritme van je sporters.
            </PrintP>
            <H5>Afstemmend</H5>
            <PrintP>
              Een afstemmende benadering betekent dat je zo veel mogelijk
              aansluiting zoekt bij het perspectief van je sporters. Je zoekt
              manieren om oefeningen interessanter en aangenamer te brengen, je
              erkent negatieve gevoelens bij je sporters en probeert zo goed
              mogelijk t            e begrijpen hoe zij de zaken zien. Je volgt hun
              ontwikkelingsritme en geeft bij het opdragen van (vervelende)
              taken een uitleg die in hun ogen betekenisvol is.
            </PrintP>
            <H5>Begeleidend</H5>
            <PrintP>
              Een begeleidende benadering betekent dat je gepaste hulp en
              begeleiding geeft aan je sporters. Je doet dat door de stappen die
              nodig zijn voor het uitvoeren van een oefening of techniek samen
              met hen door te nemen, waarna ze zelfstandig kunnen oefenen en
              vragen kunnen stellen indien nodig. Samen met je sporters sta je
              constructief stil bij gemaakte fouten, zodat ze zelf inzien wat
              beter kan en hoe ze zichzelf kunnen verbeteren.
            </PrintP>

          </div>

          <footer className="c-page__footer">
            <div className="c-page__footer-logo" />
            <span className="c-page__footer-page-number">
              Page <span className="js-footer-pagination">1</span> - Mboek -
              M-factor op { this.state.date }
            </span>
          </footer>
        </section>

        <section className="c-page c-page--form">
          <header className="c-page__header">
            <div className="c-page__header-test-info">
              <Icon id="ugent" />
            </div>
            <div className="c-page__header-organisations">
              <Icon id="ugent-ge" fillColor="rgb(30,100,200)" width="230px" />
            </div>
          </header>

          <div className="c-page__main">
            <H5>Verduidelijkend</H5>
            <PrintP>
              Een verduidelijkende benadering betekent dat je duidelijke
              verwachtingen communiceert naar je sporters; je wil hierbij
              transparant en helder zijn. Je houdt bovendien ook de vinger aan
              de pols door goed na te gaan of de gecommuniceerde verwachtingen
              goed werden gevolgd.
            </PrintP>
            <H5>Eisend</H5>
            <PrintP>
              Een eisende benadering betekent dat je discipline eist van je
              sporters door krachtige en bevelende taal te gebruiken waarin je
              duidelijk maakt wat je sporters moeten doen. Je wijst je sporters
              op hun plichten.
            </PrintP>
            <H5>Dominerend</H5>
            <PrintP>
              Een dominerende benadering betekent dat je je macht laat gelden om
              je sporters tot de orde te roepen. Je zet je sporters op hun
              plaats door hen schuld- of schaamtegevoelens aan te praten.
            </PrintP>
            <H5>Opgevend</H5>
            <PrintP>
              Een opgevende benadering betekent dat je er, na herhaaldelijke
              tussenkomsten, de brui aan geeft. Je laat sporters hun eigen zin
              doen en je zit niet langer achter hun veren, want uiteindelijk
              moeten ze leren om zelf verantwoordelijkheid te nemen voor hun
              gedrag.
            </PrintP>
            <H5>Afwachtend</H5>
            <PrintP>
              Een afwachtende benadering betekent dat je het initiatief bij je
              sporters legt. Je hebt de neiging om af te wachten wat je sporters
              zullen doen. Je plant niet te veel en laat de zaken meer op hun
              beloop.
            </PrintP>
          </div>

          <footer className="c-page__footer js-footer">
            <div className="c-page__footer-logo js-footer-content" />
            <span className="c-page__footer-page-number">
              Page <span className="js-footer-pagination">2</span> - Mboek -
              M-factor op { this.state.date }
            </span>
          </footer>
        </section>
              </Fragment>
            );
          }}
        </Query>
      </PrintContent>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/discover/ResultPDFView.js